import React from "react";
import flower from "../assets/icons/purpleFlower.webp";
import { useNavigate } from "react-router-dom";

const BlockCard = ({ blockInfo }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white flex flex-col m-2 p-8 gap-2 jusitfy-center h-fit items-center max-w-[450px] w-full rounded-[10px] shadow-md">
      <div className="flex items-center relative">
        <img src={flower} className="w-[80px]" />
        {/* <div className={`absolute inset-0 bg-black opacity-30  z-20  `} /> */}
      </div>
      <h1 className="pt-4 text-2xl font-bold font-poppins text-dark-blue">
        Bloque {blockInfo.letter}
      </h1>
      <p className=" font-poppins bg-slate-100 rounded-xl p-4 text-lg my-2">
        Inicia el{" "}
        <b>{new Date(blockInfo.initDate).toLocaleDateString("es-ES")}</b>
        <br />
        Termina el{" "}
        <b>{new Date(blockInfo.endDate).toLocaleDateString("es-ES")}</b>
        <br />
        Intervalo de <b>{blockInfo.interval} días</b>
      </p>

      <button
        className="mt-4 w-fit bg-dark-green text-xl  rounded-full py-4 px-8 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
        Registrar
        onClick={() => navigate(blockInfo.letter)}
      >
        Registrar
      </button>
    </div>
  );
};

export default BlockCard;
